import React from 'react';
import './ConfirmationModal.css';

interface LicenseErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LicenseErrorModal: React.FC<LicenseErrorModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="confirmation-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="license-error-modal-title"
    >
      <div className="confirmation-modal">
        <div className="confirmation-modal-header">
          <h3 id="license-error-modal-title" className="confirmation-modal-title">
            ⚠️ ライセンスが有効ではありません
          </h3>
        </div>

        <div className="confirmation-modal-body">
          <p className="confirmation-modal-message">
            このインスタンスには <strong>コラボフロー for 商奉行</strong>{' '}
            の有効なライセンスが見つかりませんでした。
          </p>
          <p className="confirmation-modal-message">
            ご利用にはライセンスが必要です。ご契約内容の確認またはライセンス追加については、
            コラボフロー担当者またはサポート窓口にお問い合わせください。
          </p>
        </div>

        <div className="confirmation-modal-footer">
          <button
            className="confirmation-modal-button confirm-button primary"
            onClick={onClose}
            autoFocus
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenseErrorModal;
